import { useReducedMotion } from 'framer-motion';
import { AGENT_STATUS_SHIMMER_SPREAD } from '@/components/chat/agent-status-shimmer-row';
import { Shimmer } from '@/components/ui/shimmer';
import { cn } from '@/lib/utils';

/** Slower, softer sweep than voice status — reads better on a row of pills. */
export const CAPABILITY_PILL_SHIMMER_DURATION = 3;
/** Fixed offset between pills so concurrent prefetches do not pulse in lockstep. */
export const CAPABILITY_PILL_SHIMMER_STAGGER_S = 0.12;

interface CapabilityCategoryPillLabelProps {
  title: string;
  streaming?: boolean;
  /** Index among visible pills — drives staggered animation delay. */
  staggerIndex?: number;
  className?: string;
}

/** Category pill label — shimmers L→R while drawer examples prefetch over SSE. */
export function CapabilityCategoryPillLabel({
  title,
  streaming = false,
  staggerIndex = 0,
  className,
}: CapabilityCategoryPillLabelProps) {
  const reduceMotion = useReducedMotion();
  const showShimmer = streaming && !reduceMotion;

  if (showShimmer) {
    return (
      <Shimmer
        as="span"
        duration={CAPABILITY_PILL_SHIMMER_DURATION}
        spread={AGENT_STATUS_SHIMMER_SPREAD}
        delay={staggerIndex * CAPABILITY_PILL_SHIMMER_STAGGER_S}
        highlight="soft"
        className={cn('min-w-0 truncate', className)}
      >
        {title}
      </Shimmer>
    );
  }

  return <span className={cn('truncate', className)}>{title}</span>;
}
